/**
 * API / WebSocket base URLs for dev vs production.
 *
 * In dev, leave VITE_API_URL unset and use `npm run dev -- --host` so the browser
 * talks to the same host:port as Vite; /api and /ws are proxied to Spring Boot.
 * That avoids CORS when opening http://192.168.x.x:3000 from another device.
 */
export function getApiBaseUrl() {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  if (import.meta.env.DEV) {
    return '';
  }
  return 'http://localhost:8080';
}

export function getWsBaseUrl() {
  if (import.meta.env.VITE_WS_URL) {
    return import.meta.env.VITE_WS_URL;
  }
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${proto}//${window.location.host}`;
  }
  return 'ws://localhost:8080';
}
